import { api, ApiError } from "./api";

export async function openCaseFilePreview(
  caseId: string,
  params: { fieldKey: string } | { commentId: string; fileKey: string },
): Promise<void> {
  const qs = new URLSearchParams();
  if ("fieldKey" in params) {
    qs.set("fieldKey", params.fieldKey);
  } else {
    qs.set("commentId", params.commentId);
    qs.set("fileKey", params.fileKey);
  }
  try {
    const res = await api<{ url: string }>(`/ai/cases/${caseId}/file-preview?${qs.toString()}`);
    window.open(res.url, "_blank", "noopener,noreferrer");
  } catch (e) {
    throw e instanceof ApiError ? e : new Error("Could not open attachment");
  }
}
